/**
 * «Мир Квестов» (партнёрская площадка, A14): как узнать игру оттуда и обязательная отметка исхода.
 * Одно правило для сервера (game-reports: сдача отчёта, PUT …/mk-status) и приложения сотрудников
 * (белая рамка игры, форма отчёта, карточка игры оператора).
 *
 * 10.10.2026 (владелец): «сейчас не все операторы отмечают отмену/оценки — это должны отмечать
 * все». Отметка (✕ — отменили / 5.0 — оценки) обязательна в отчёте КАЖДОГО оператора игры,
 * и основного, и напарника, — для игр с даты запуска: пересдача старых отчётов её не требует.
 */

/** Совпадение по источнику без учёта регистра и пробела («Мир Квестов», «мир квест», …);
 *  26.08: зеркальные заказы V4 пишут латиницей «mir-kvestov.ru». */
export function isMirKvSource(source?: string | null): boolean {
  return !!source && /мир\s*квест|mir-?kvestov/i.test(source);
}

/** С этой даты игры (YYYY-MM-DD) отчёт без отметки Мира Квестов не принимается. */
export const MK_MARK_REQUIRED_FROM = "2026-10-10";

export type MkMark = "score" | "cancel";
export const isMkMark = (v: unknown): v is MkMark => v === "score" || v === "cancel";

/** Нужна ли отметка в отчёте по этой игре: она с Мира Квестов и не раньше даты запуска. */
export function mkMarkRequired(source: string | null | undefined, gameDate: string | null | undefined): boolean {
  return isMirKvSource(source) && typeof gameDate === "string" && gameDate.slice(0, 10) >= MK_MARK_REQUIRED_FROM;
}

/** Текст отказа — один для формы и сервера. */
export const MK_MARK_ERROR = "Отметь «Мир Квестов»: ✕ — отменили или 5.0 — оценки.";
